export const EmployeeAttendanceMode = {
  DIALOG: 'DIALOG',
  PHONE: 'PHONE',
  MAIN: 'MAIN',
};
